import { render, staticRenderFns } from "./subConfig.vue?vue&type=template&id=7b3d6830&scoped=true"
import script from "./subConfig.vue?vue&type=script&lang=js"
export * from "./subConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3d6830",
  null
  
)

export default component.exports